import moment from "moment";
import { BaseReq, PaginationReq, PaginationResp, UpdaterResp,FileRecord } from "@/core/interface";

export enum ChangeTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}

export class ChangeReq extends BaseReq {
  safetyCheckId: string | undefined = undefined; // 安检记录 ID
  name: string | undefined = undefined; // 项目名称
  changeDeptName: string = ""; // 整改部门
  changeIssueDate: string = moment().format("YYYY-MM-DD"); // 整改下发日期
  changeCompleteDate: string = moment().format("YYYY-MM-DD"); // 要求完成日期
  changeTenantUserId: string | undefined = undefined; // 整改负责人
  checkTenantUserId: string | undefined = undefined; // 检查人
  isChange: boolean = false; // 是否需要整改
  checkContent: string = ""; // 整改内容
  remark: string = ""; // 备注
  imgUrl: string[] = []; // 现场图片
  fileList: FileRecord[]; //附件
  projectId: string | undefined = undefined; // 项目 ID
}

export class ChangePageReq extends PaginationReq {
  bizNo: string | undefined = undefined; // 整改编号
  name: string | undefined = undefined; // 项目名称
  changeStartDate: string | undefined = undefined; // 检查结束日期
  changeFinishDate: string | undefined = undefined; // 检查开始日期
  isChange: boolean | undefined = undefined; // 整改状态
  changeTenantUserId: string | undefined = undefined; // 整改负责人
  checkTenantUserId: string | undefined = undefined; // 检查人
  flowStatus: string = "";  //状态
  skipProjectRight: number | undefined = undefined;
  addRightBizType: string | undefined = undefined;
  projectId: string | undefined = undefined; // 项目 ID
  firstDisplayProjectId: string | undefined = undefined;
}

export class ChangeListRecord extends UpdaterResp {
  id: string = ""; // 安全整改单ID
  bizNo: string = ""; // 安全整改单编号
  name: string = ""; // 项目名称
  changeTenantUserId: string = ""; // 整改负责人 ID
  changeTenantUserIdName: string = ""; // 整改负责人名称
  changeIssueDate: string = ""; // 整改下发日期
  changeCompleteDate: string = ""; // 要求完成日期
  safetyCheckId: string = ""; // 关联安检记录 ID
  safetyCheckBizNo: string = ""; // 关联安检记录编号
  checkTenantUserId: string = ""; // 检查人 ID
  checkTenantUserName: string = ""; // 检查人名称
  isChange: boolean | undefined = undefined; // 整改状态
  flowStatusName: string = ""; // 审批状态
  lastModifiedTime: string = ""; // 更新时间
}

export class ChangePageResp extends PaginationResp<ChangeListRecord> {}

export class ChangeDetailResp extends UpdaterResp {
  id: string = ""; // 安全整改单 ID
  safetyCheckId: string = ""; // 关联安检记录 ID
  safetyCheckBizNo: string = ""; // 关联安检记录编号
  name: string = ""; // 项目名称
  changeDeptName: string = ""; // 整改部门
  changeIssueDate: string = ""; // 整改下发日期
  changeCompleteDate: string = ""; // 要求完成日期
  changeTenantUserId: string = ""; // 整改负责人 ID
  changeTenantUserIdName: string = ""; // 整改负责人名称
  isChange: boolean | undefined = undefined; // 整改状态
  checkTenantUserId: string = ""; // 检查人 ID
  checkTenantUserName: string = ""; // 检查人名称
  checkContent: string = ""; // 整改内容
  remark: string = ""; // 备注
  imgUrl: string[] = []; // 现场图片
}

export class ChangeSimpleListReq {
  changeCompleteDate: string | undefined = undefined; // 要求完成日期
  changeDeptName: string | undefined = undefined; // 整改部门
  changeIssueDate: string | undefined = undefined; // 整改下发日期
  changeTenantUserId: string | undefined = undefined; // 整改负责人
  checkContent: string | undefined = undefined; // 整改内容
  checkTenantUserId: string | undefined = undefined; // 检查人
  flowStatus: string | undefined = undefined; // 审批状态
  isChange: boolean | undefined = undefined; // 整改状态
  safetyCheckId: string | undefined = undefined; // 安全检查 ID
  ids: string[] | undefined = undefined;
}

class ChangeSimpleRecord {
  id: string = "";
  bizNo: string = "";
}

export class ChangeSimpleListResp {
  records: ChangeSimpleRecord[] = [];
}
